import React from 'react';
import { Dropdown } from 'antd';

import { Icon, Button, DropDownMenu } from '..';

import style from './Button.module.scss';


export const IconButton = ({ onClick, icon, dropdownItems, disabled = false }) => (

  !dropdownItems
    ? (
      <Button
        vendorClass={ style.iconButton }
        onClick={ onClick }
        disabled={ disabled }
      >
        <Icon
          svg={ icon }
        />
      </Button>
    )
    : (
      <Dropdown
        overlay={ <DropDownMenu items={ dropdownItems } /> }
      >
        <div>
          <Button
            vendorClass={ style.iconButton }
            disabled={ disabled }
          >
            <Icon
              svg={ icon }
            />
          </Button>
        </div>
      </Dropdown>
    )
);
